import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';

import logoSmall from './assets/pw-logo-color.svg';
import logoLarge from './assets/pw-logo-horizontal-color-dark.svg';

class Logo extends React.Component {
  render() {
    const { collapsed } = this.props;

    return (
      <Link
        to="/"
        style={
          collapsed
            ? {
                display: 'flex',
                justifyContent: 'center',
                width: '90px',
              }
            : {}
        }
      >
        {collapsed ? (
          <img width="80" height="80" alt="Wingman" src={logoSmall} />
        ) : (
          <img
            width="243.73"
            height="76.8"
            className="logo-large"
            alt="Wingman"
            src={logoLarge}
          />
        )}
      </Link>
    );
  }
}

Logo.propTypes = {
  collapsed: PropTypes.bool,
};

Logo.defaultProps = {
  collapsed: false,
};

export default Logo;
